<template>
  <div v-if="all_items.length" class="table-responsive" style="margin-top: 1.2vw;">
    <table class="table table-striped bg-white" style="width: 70vw; ">
      <thead>
      <tr class="sticky-header">
        <th rowspan="2" style="width: 1vw;">ردیف</th>
        <th rowspan="2">اقدام پیشران</th>
        <th rowspan="2">مسئله</th>
        <th rowspan="2"> مأموریت</th>
        <th rowspan="2">کلان خدمت</th>
        <th colspan="3">زیرخدمت</th>
      </tr>
      <tr>
        <th>عنوان</th>
        <th>نهاده</th>
        <th class="nowrap">زنجیره نتایج</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(item, index) in all_items" :key="item.id">
        <!-- Main Row -->
        <tr>
          <td :rowspan="item.sub_processes.length || 1">{{ index + 1 }}</td>
          <td :rowspan="item.sub_processes.length || 1">
            <ul style="padding: 0 2vw; list-style: persian;">
              <li v-for="(propulsionAction, propulsionActionIndex) in item.propulsion_basic_actions"
                  :key="propulsionActionIndex" class="my-2">
                {{ propulsionAction.title }}
              </li>
            </ul>
          </td>
          <td :rowspan="item.sub_processes.length || 1">{{ item.title }}</td>
          <td :rowspan="item.sub_processes.length || 1">{{ item.determining_missions }}</td>
          <td :rowspan="item.sub_processes.length || 1">{{ item.processes?.title }}</td>

          <template v-if="item.sub_processes.length">
            <td>{{ item.sub_processes[0].title }}</td>
            <td>
              <button
                  @click.prevent="openModal(item.sub_processes[0].id, item.title)"
                  class="btn btn-submit-1 btn-primary"
              >
                تکمیل | بروزرسانی
              </button>
            </td>
            <td>
              <button
                  @click.prevent="openModalTwo(item.sub_processes[0].id, item.title, item.sub_processes[0].definition_of_outputs, item.sub_processes[0].intermediate_outcomes)"
                  class="btn btn-submit-1 btn-primary"
              >
                تکمیل | بروزرسانی
              </button>
            </td>
          </template>

          <template v-else>
            <td>--</td>
            <td>--</td>
            <td>--</td>
          </template>
        </tr>

        <!-- Additional Rows for Subprocesses -->
        <template v-if="item.sub_processes.length">
          <tr v-for="sub in item.sub_processes.slice(1)" :key="sub.id">
            <td>{{ sub.title }}</td>
            <td>
              <button
                  @click.prevent="openModal(sub.id, item.title)"
                  class="btn btn-submit-1 btn-primary"
              >
                تکمیل | بروزرسانی
              </button>
            </td>
            <td>
              <button
                  @click.prevent="openModalTwo(
                      sub.id,
                      item.title,
                      sub.definition_of_outputs,
                      sub.intermediate_outcomes
                  )"
                  class="btn btn-submit-1 btn-primary"
              >
                تکمیل | بروزرسانی
              </button>
            </td>
          </tr>
        </template>
      </template>
      </tbody>
    </table>
  </div>

 

  <button  @click.prevent="exportWord"  class="btn btn-primary btn-submit-1 mt-2">خروجی Word</button>
 <InputsInformations :show_insert="true" :status="modalOne" @close="closeModal" :title="title_process"  :id="id_process"
                       />
  <ChainInformations :show_insert="true"  :intermediate_outcomes="intermediate_outcomes" :definition_of_outputs="definition_of_outputs" :status="modalTwo" @close="closeModal" :title="title_process"  :id="id_process"  />

</template>
<script>
import InputsInformations from "@/components/Impact_Assessment/Input/InputsInformations.vue";
import ChainInformations from "@/components/Impact_Assessment/Input/ChainInformations.vue";

export default {
  components: {ChainInformations, InputsInformations},
  data() {
    return {
      id_route: this.$route['params']['id'],
      all_items: [],
      definition_of_outputs:[] ,
      intermediate_outcomes: [],
      modalOne: false,
      modalTwo: false,
      title_process: '', // Initialize these variables
      id_process: null

    }
  },
  methods: {
    exportWord() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`); // اضافه کردن توکن
      const formdata = new FormData();
      formdata.append('company_id', this.id_route);
      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/impact-assessment/get_word`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.download_url) {
              // باز کردن لینک در تب جدید
              window.open(result.download_url, '_blank');
            } else {
              throw new Error('Download URL not provided');
            }
          })
          .catch(error => {
            toast.error('خطا در دریافت فایل!');
          });
    },
    openModal(id, title) {
      this.modalOne = true;
      this.title_process = title; // Use title_process here
      this.id_process = id; // Use id_process here
    },
    openModalTwo(id, title,definition_of_outputs,intermediate_outcomes) {
      this.modalTwo = true;
      this.title_process = title; // Use title_process here
      this.id_process = id; // Use id_process here
      this.definition_of_outputs=definition_of_outputs
      this.intermediate_outcomes=intermediate_outcomes

    },
    closeModal() {
      this.modalOne = false;
      this.modalTwo = false;
    },
    all() {
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);
      var formdata = new FormData();
      formdata.append('company_id', this.id_route)
      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/Problem_identification/completed_problems_Impact_Assessment`, requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.error) {
              this.Error = true
              this.ErrorM = result.error
              return
            }
            if (result.data.completed_problems && result.data && result.data.completed_problems.details) {
              this.all_items = result.data.completed_problems.details
            }


          })
          .catch();
    },
  },
  mounted() {
    this.all()
  },
}

</script>
<style scoped>

</style>